import {init as initApm} from "@elastic/apm-rum"

declare const SERVICE_VERSION: string

export const apm = initApm({
  serviceName: "ssn-web-client",
  serverUrl:
    process.env.NODE_ENV === "production"
      ? location.origin
      : "http://127.0.0.1:8200",
  serviceVersion: SERVICE_VERSION,
  distributedTracingOrigins: [
    process.env.NODE_ENV === "production"
      ? "http://ssn-api:8881"
      : "http://localhost:8881",
  ],
  active: process.env.NODE_ENV === "production",
})
